
import Vue from "vue";
import { Component, PropSync, Prop } from "vue-property-decorator";

@Component
export default class OTPForm extends Vue {
  // 📦 Email that the user enters
  @Prop()
  public email!: string | null;

  // 📦 The OTP code the user enters
  @PropSync("userOtpCode")
  public otpCode!: string | null;

  // 🔃 Flag responsible for showing loading indicator
  @Prop()
  private isLoading: boolean = false;

  // 👮‍♂️ OTP validation rules
  private otpRules = [
    (v: string) =>
      (!!v && v.trim().length > 0 && /^\d+$/.test(v.trim())) ||
      "Please provide a valid 2FA code",
  ];

  // 🚩 Flag for whether the provided otp code is valid
  private get isProvidedInformationValid(): boolean {
    return (
      this.otpCode != null &&
      this.otpCode.trim().length > 0 &&
      /^\d+$/.test(this.otpCode.trim())
    );
  }
}
